import { render } from "./Proclimation.vue?vue&type=template&id=4b7f1373&scoped=true&bindings={\"news\":\"data\",\"title\":\"setup\",\"showNews\":\"setup\",\"showHideNews\":\"setup\"}"
import script from "./Proclimation.vue?vue&type=script&lang=js"
export * from "./Proclimation.vue?vue&type=script&lang=js"

import "./Proclimation.vue?vue&type=style&index=0&id=4b7f1373&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4b7f1373"

export default script